import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Document\GetListDocumentDossierController::__invoke
* @see app/Http/Controllers/Document/GetListDocumentDossierController.php
* @route '/api/dossier/{dossier}/document'
*/
const GetListDocumentDossierController = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetListDocumentDossierController.url(args, options),
    method: 'get',
})

GetListDocumentDossierController.definition = {
    methods: ["get","head"],
    url: '/api/dossier/{dossier}/document',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Document\GetListDocumentDossierController::__invoke
* @see app/Http/Controllers/Document/GetListDocumentDossierController.php
* @route '/api/dossier/{dossier}/document'
*/
GetListDocumentDossierController.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return GetListDocumentDossierController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Document\GetListDocumentDossierController::__invoke
* @see app/Http/Controllers/Document/GetListDocumentDossierController.php
* @route '/api/dossier/{dossier}/document'
*/
GetListDocumentDossierController.get = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetListDocumentDossierController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Document\GetListDocumentDossierController::__invoke
* @see app/Http/Controllers/Document/GetListDocumentDossierController.php
* @route '/api/dossier/{dossier}/document'
*/
GetListDocumentDossierController.head = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetListDocumentDossierController.url(args, options),
    method: 'head',
})

export default GetListDocumentDossierController